<template>
	<div v-if="$localStorage.get('user').username.role==3" class="d-flex" style="justify-content: space-between;">
        <btn 
            :badje="flds.data.contentAll"
            type='light-gray'
            style="width: 19%;" 
            :textClass="'w-100 text-14 '+((!$route.query.status || $route.query.status=='0') ? 'shadow': '')"
            style_btn="height: 72px; border-radius: 20px;" 
            text="جدید / در صف بررسی" 
            @clickMe="set_url_val(0)"
        />
        <btn 
            type='light-yellow'
            style="width: 19%;" 
            style_btn="height: 72px; border-radius: 20px;" 
            text="در دست بررسی" 
            @clickMe="set_url_val(1)"
            :textClass="'w-100 text-14 '+(($route.query.status=='1') ? 'shadow': '')"
        />
        <btn 
            type='light-blue'
            style="width: 19%;" 
            style_btn="height: 72px; border-radius: 20px;" 
            text="جواب داده شده" 
            @clickMe="set_url_val(2)"
            :textClass="'w-100 text-14 '+(($route.query.status=='2') ? 'shadow': '')"
        />
        <btn 
            type='light-red'
            style="width: 19%;" 
            style_btn="height: 72px; border-radius: 20px;" 
            text="نگه داشته شده" 
            @clickMe="set_url_val(3)"
            :textClass="'w-100 text-14 '+(($route.query.status=='3') ? 'shadow': '')"
        />
        <btn 
            type='light-green'
            style="width: 19%;" 
            style_btn="height: 72px; border-radius: 20px;" 
            text="پایان یافته" 
            @clickMe="set_url_val(4)"
            :textClass="'w-100 text-14 '+(($route.query.status=='4') ? 'shadow': '')"
        />
    </div>
</template>

	<script>
		import btn from  "../../UI/button/btn.vue";

		export default {
			name: 'part1_admin_btns',
			data(){
				return {

				}
			},
			components: {
				btn,
			},
			props: ["flds"],
			mounted(){
                
			},
			methods:{
				set_url_val(id){
                    let query = { status: id.toString() };
                    for (let q in this.$route.query) {
                        if (q != 'status') {
                            query[q] = this.$route.query[q];
                        }
                    }
                    query.page = 1;
                    this.$router.push({query: query});
                    this.$emit("click", id);
                }
			}
		}
	</script>
<style>

</style>
